// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GitlabOutlinedSvg from "@fishx/icons-svg/es/asn/GitlabOutlined";
import FishxIcon from '../components/FishxIcon';

var GitlabOutlined = function GitlabOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GitlabOutlinedSvg
  }));
};

GitlabOutlined.displayName = 'GitlabOutlined';
export default React.forwardRef(GitlabOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GitlabOutlined.js
// module id = 2873
// module chunks = 0